import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "app__card"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "container",
  "data-block": "catalog"
}, [
  /*#__PURE__*/_createElementVNode("h1", { class: "app__title" }, "Мраморная говядина")
], -1)
const _hoisted_3 = ["data-section"]
const _hoisted_4 = { class: "app__subtitle" }
const _hoisted_5 = { class: "app__cards" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CatalogItem = _resolveComponent("CatalogItem")!

  return (_ctx.catalog)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.catalog.sections, (section, sIdx) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "container app__container",
            "data-section": section.id,
            key: sIdx
          }, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(section.name), 1),
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getItemsBySectionId(section.id), (item, idx) => {
                return (_openBlock(), _createBlock(_component_CatalogItem, {
                  key: idx,
                  item: item
                }, null, 8, ["item"]))
              }), 128))
            ])
          ], 8, _hoisted_3))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}